
import { Options, Vue } from "vue-class-component";
import NavBar from "@/components/Nav/NavBar.vue"; // @ is an alias to /src
import Footer from "@/components/Footer/Footer.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
@Options({
  components: {
    NavBar,
    Footer,
    FontAwesomeIcon  },
})
export default class App extends Vue {
  trigger=""
  OnChangedVal(){
    this.trigger=Math.random().toString()
  }
}
